import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { rememberHallReturnRoute } from "@/lib/hallReturnRoute.mjs";

export default function HallReturnRouteMemory() {
  const location = useLocation();

  useEffect(() => {
    rememberHallReturnRoute(location, window.sessionStorage);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
